var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tc-heading-style6"},[_c('h3',{staticClass:"heading-inner"},[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }